// eslint-disable-next-line func-names
export default function () {
    return {
        thanks: 'Спасибо',
        empty: 'Обязательно для заполнения.',
        emptyName: ' Пожалуйста, введите свое имя.',
        emptyPhone: 'Пожалуйста, введите свой номер телефона.',
        emptyEmail: 'Пожалуйста, введите свой адрес email.',
        incorrectEmail: 'Неправильный E-mail.',
        textSuccess: 'Успешно!',
        textSuccessSubscribe: 'Спасибо за подписку!',
        textSubscribed: 'Ваша подписка была подтверждена.',
        textSuccessCommentTitle: 'Спасибо за комментарий!',
        textSuccessComment: 'Ваш комментарий получен и будет опубликован после просмотра его модератором.',
        textError: 'Извините, произошла ошибка :(',
        textLoadError: 'Не удалось загрузить данные. Возможно, нет доступа к интернету. Проверьте подключение к сети и попробуйте еще раз.',
        textRequestError: 'Ошибка при отправке формы, попробуйте еще раз, но позже ...',
        textRequest: 'Ваш запрос успешно отправлен!',
        minLengthName: 'Введите не менее 2 символов.',
        minLengthText: 'Введите не менее 20 символов.',
        maxLengthName: 'Имя от 2 до 33 символов!.',
        maxLengthText: 'Текст от 20 до 1000 символов!.',
    };
}
